import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class TokenService {
  readonly tokenKey = "___MOPC_TOKEN__";

  private _b64decode(str: string) {
    const chars =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";

    let output = "";

    str = String(str).replace(/=+$/, "");

    if (str.length % 4 == 1) {
      throw new Error(
        "'atob' failed: The string to be decoded is not correctly encoded."
      );
    }
    for (
      // initialize result and counters
      let bc = 0, bs = void 0, buffer = void 0, idx = 0; // get next character
      (buffer = str.charAt(idx++)); // character found in table? initialize bit storage and add its ascii value;
      ~buffer &&
      ((bs = bc % 4 ? bs * 64 + buffer : buffer), // and if not first of each 4 characters,
      // convert the first 8 bits to one ascii character
      bc++ % 4)
        ? (output += String.fromCharCode(255 & (bs >> ((-2 * bc) & 6))))
        : 0
    ) {
      // try to find character in table (0-63, not found => -1)
      buffer = chars.indexOf(buffer);
    }

    return output;
  }

  private _b64DecodeUnicode(str: string) {
    return decodeURIComponent(
      Array.prototype.map
        .call(this._b64decode(str), function (c) {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join("")
    );
  }

  private _urlBase64Decode(str: string): string {
    let output = str.replace(/-/g, "+").replace(/_/g, "/");

    switch (output.length % 4) {
      case 0: {
        break;
      }
      case 2: {
        output += "==";
        break;
      }
      case 3: {
        output += "=";
        break;
      }
      default: {
        throw new Error("Illegal base64url string!");
      }
    }

    return this._b64DecodeUnicode(output);
  }

  setToken(token: string) {
    localStorage.setItem(this.tokenKey, token);
  }

  getToken(): string {
    return localStorage.getItem(this.tokenKey);
  }

  toJSON(accessToken: string) {
    return JSON.parse(this.decodeToken(accessToken));
  }

  getValueFromClaim(accessToken: string, claim: string): string {
    return this.decodeToken(accessToken)[claim];
  }

  isTokenExpired(accessToken: string, offsetSeconds?: number): boolean {
    // tokenName = this.getToken();
    const tokenName = accessToken;

    if (tokenName == null) {
      return true;
    }

    const date = this.getTokenExpirationDate(accessToken);

    offsetSeconds = offsetSeconds || 0;

    if (date == null) {
      return false;
    }

    // Token expired?
    const result = !(
      date.valueOf() >
      new Date().valueOf() + offsetSeconds * 1000
    );

    return result;
  }

  decodeToken(accessToken: string): any {
    const parts = accessToken.split(".");

    if (parts.length !== 3) {
      throw new Error("JWT must have 3 parts");
    }

    const decoded = this._urlBase64Decode(parts[1]);

    if (!decoded) {
      throw new Error("Cannot decode the token");
    }

    return JSON.parse(decoded);
  }

  getTokenExpirationDate(accessToken: string): Date {
    const decoded = this.decodeToken(accessToken);

    if (!decoded.hasOwnProperty("exp")) {
      return null;
    }

    const date = new Date(0); // The 0 here is the key, which sets the date to the epoch

    date.setUTCSeconds(decoded.exp);

    return date;
  }
}
